<div class="progress-wrapper">
    <div class="progress-bar">
        <div class="progress" [ngStyle]="{ 'width' : getProgressPercent() + '%' }">
            <img src="assets/img/freeroll-progress/freeroll-progress.webp" alt="">
        </div>
    </div>
    <div class="text">{{ currentPoints() }} / {{necessaryPoints()}}</div>
</div>
